<h3>Interromper Férias</h3>
<a href="#" class="sr-only">Interromper Férias</a>
<style>
    @media (max-width: 960px) {
        div.p-tooltip-top > div.p-tooltip-text {
            margin-top: -10px !important;
            margin-bottom: -10px !important;
        }
        div.p-tooltip-arrow {
            display: none;
        }
    }
</style>
<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="true" [exibirTipoPeriodoAquisitivo]="false"></app-cabecalho-funcional>
<p-steps [model]="itensWizard" [readonly]="true" [activeIndex]="wizardActiveIndex"></p-steps>
<div class="row" *ngIf="wizardActiveIndex == 0">
    <div class="col-sm-12">
        <ng-container *ngFor="let parcela of parcelasFeriasParaInterrupcao; let i = index">
            <h4 style="color: var(--active)">{{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}ª Parcela</h4>
            <div class="br-card">
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-data-inicio_' + i">Período de Férias</label>
                        <br />
                        <p class="mb-0">
                            {{ parcela.dataInicio | dataFormatada }} a
                            {{ parcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label>Quantidade de dias</label>
                        <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <p class="label mb-1">Adicionais de Férias</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro.valor">Adiantamento 13º</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoSalarial.valor">Adiantamento Salarial</p>
                        <p class="mb-0" *ngIf="parcela.abonoPecuniario.valor">Abono Pecuniário</p>
                        <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro.valor && !parcela.adiantamentoSalarial.valor && !parcela.abonoPecuniario.valor">Não solicitado</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 br-input">
                        <p *ngIf="parcela.adiantamentoSalarial.valor" class="label mb-1">Parcelas de Desconto</p>
                        <p *ngIf="parcela.adiantamentoSalarial.valor" class="mb-0">
                            {{ parcela.parcelasDesconto }}
                        </p>
                    </div>
                </div>
                <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.selecionadaParaInterrupcao">
                    <div class="col-12 col-lg-4">
                        <div class="row">
                            <div class="col-12 col-lg-6 mt-2 br-input" [ngClass]="!parcela.dataInterrupcao && submetido ? 'danger' : ''">
                                <label [for]="'campo-data-interrucao_' + i">Data da Interrupção (Obrigatório)</label>
                                <br />
                                <p-calendar [inputId]="'campo-data-interrucao_' + i" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [(ngModel)]="parcela.dataInterrupcao" [showOtherMonths]="false" [minDate]="parcela.dataMinimaInterrupcao" [maxDate]="parcela.dataFim" [defaultDate]="parcela.dataMinimaInterrupcao" (onSelect)="dataInterrupcaoChange(parcela)" (onBlur)="blurDataInterrupcaoChange(parcela, $event)" (onInput)="inputDataInterrupcaoChange(parcela, $event)"></p-calendar>
                                <p class="mt-1" *ngIf="!parcela.dataInterrupcao && submetido">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                                <p class="mt-1" *ngIf="parcela.validacao.dataInterrupcaoInvalida">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Data inválida!
                                    </span>
                                </p>
                                <p class="mt-1" *ngIf="parcela.validacao.dataInterrupcaoForaPeriodoFerias">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        {{ getMsgDataInterrupcaoForaPeriodoFerias(parcela) }}
                                    </span>
                                </p>
                            </div>
                            <div class="col-12 col-lg-6 mt-2 br-input" [ngClass]="!parcela.motivoLegal && submetido ? 'danger' : ''">
                                <label [for]="'campo-motivo-legal_' + i">Motivo Legal (Obrigatório)</label>
                                <p-dropdown [inputId]="'campo-motivo-legal_' + i" [options]="['Calamidade Pública', 'Comoção Interna', 'Convocação para Júri', 'Necessidade do Serviço', 'Serviço Militar ou Eleitoral']" [(ngModel)]="parcela.motivoLegal" placeholder="Selecione" [editable]="false" styleClass="mt-1">
                                    <ng-template pTemplate="clearicon">
                                        <span class="fas fa-times"></span>
                                    </ng-template>
                                    <ng-template pTemplate="dropdownicon">
                                        <span class="fas fa-chevron-down"></span>
                                    </ng-template>
                                </p-dropdown>
                                <p class="mt-1" *ngIf="!parcela.motivoLegal && submetido">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-lg-6 mt-2 br-input" [ngClass]="(!parcela.documentoLegal || parcela.documentoLegal.trim().length <= 0) && submetido ? 'danger' : ''">
                                <label [for]="'campo-portaria_' + i">Documento Legal (Obrigatório)</label>
                                <input [id]="'campo-portaria_' + i" pInputText [(ngModel)]="parcela.documentoLegal" mask="00000" maxlength="5" />
                                <p class="mt-1" *ngIf="(!parcela.documentoLegal || parcela.documentoLegal.trim().length <= 0) && submetido">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                            </div>
                            <div class="col-12 col-lg-6 mt-2 br-input" [ngClass]="!parcela.dataPublicacaoDocumentoLegal && submetido ? 'danger' : ''">
                                <label [for]="'campo-data-publicacao_' + i">Data da Publicação (Obrigatório)</label>
                                <br />
                                <p-calendar [inputId]="'campo-data-publicacao_' + i" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [(ngModel)]="parcela.dataPublicacaoDocumentoLegal" [showOtherMonths]="false" (onSelect)="dataPublicacaoChange(parcela)" (onBlur)="blurDataPublicacaoChange(parcela, $event)" (onInput)="inputDataPublicacaoChange(parcela, $event)"></p-calendar>
                                <p class="mt-1" *ngIf="!parcela.dataPublicacaoDocumentoLegal && submetido">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                                <p class="mt-1" *ngIf="parcela.validacao.dataPublicacaoInvalida">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Data inválida!
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="br-textarea col-12 col-lg-8 mt-2" [ngClass]="{ danger: (parcela.motivoLegal === 'Necessidade do Serviço' && (!parcela.justificativaInterrupcao || parcela.justificativaInterrupcao.trim().length === 0) && submetido) || parcela.validacao.justificativaInterrupcaoInvalida }">
                        <label [for]="'textarea-justificativa-parcela_' + i">Justificativa de interrupção da parcela {{ parcela.motivoLegal === "Necessidade do Serviço" ? "(Obrigatório)" : "" }}</label>
                        <textarea [id]="'textarea-justificativa-parcela_' + i" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" maxlength="300" [(ngModel)]="parcela.justificativaInterrupcao" maxlength="300" (input)="onJustificativaChangeInterrupcao($event, parcela)" (blur)="validarJustificativaInterrupcao(parcela)"></textarea>
                        <div class="text-base mt-1">
                            <span class="limit" aria-live="polite">
                                <b>{{ parcela.justificativaInterrupcao.length }}</b>
                                de
                                <b>300</b>
                                caracteres digitados
                            </span>
                            <span class="current" aria-live="polite" role="status" id="limitmax"></span>
                        </div>
                        <p class="mt-1" *ngIf="(parcela.motivoLegal === 'Necessidade do Serviço' && (!parcela.justificativaInterrupcao || parcela.justificativaInterrupcao.trim().length === 0) && submetido) || parcela.validacao.justificativaInterrupcaoInvalida">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                {{ parcela.motivoLegal === "Necessidade do Serviço" ? msgJustificativaObrigatoria : msgJustificativaInvalida }}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row" *ngIf="parcela.podeInterromper && !parcela.selecionadaParaInterrupcao" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2 text-right">
                        <button [id]="'botao-interromper-parcela_' + i" pButton type="button" label="Interromper" class="botao-responsivo" (click)="selecionarParcelaParaInterromper(parcela)"></button>
                    </div>
                </div>
                <div class="row" *ngIf="parcela.podeInterromper && parcela.selecionadaParaInterrupcao" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2 text-right">
                        <button [id]="'botao-desistir-interromper-parcela_' + i" pButton type="button" label="Desistir" class="botao-responsivo" (click)="desistirSelecaoParcelaParaInterromper(parcela)"></button>
                    </div>
                </div>
                <div class="row" style="padding-bottom: 10px">
                    <!--padding-bottom-->
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row" *ngIf="wizardActiveIndex == 1">
    <div class="col-sm-12">
        <ng-container *ngFor="let novaParcela of novasParcelasFerias; let i = index">
            <h4 style="color: var(--active)">{{ novaParcela.ordem + (novaParcela.geracao > 0 ? "." + novaParcela.geracao : "") }}ª Parcela</h4>
            <div class="br-card">
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-10 col-lg-2 mt-2 br-datetimepicker br-input" [ngClass]="(!novaParcela.dataInicio && submetido) || novaParcela.validacao.foraJanelaProgramacao || novaParcela.validacao.sobreposto ? 'danger' : ''">
                        <label [for]="'campo-data-inicio_' + i">Data de início (Obrigatório)</label>
                        <br />
                        <p-calendar [inputId]="'campo-data-inicio_' + i" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [showOtherMonths]="false" [(ngModel)]="novaParcela.dataInicio" [minDate]="novaParcela.dataMinimaReprogramacao" [maxDate]="dataMaximaParcela" [defaultDate]="novaParcela.dataMinimaReprogramacao" (onSelect)="dataInicioChange(novaParcela)" (onInput)="inputDataInicioChange(novaParcela, $event)" (onBlur)="blurDataInicioChange(novaParcela, $event)"></p-calendar>
                        <p class="mt-1" *ngIf="!novaParcela.dataInicio && submetido">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label>Quantidade de dias</label>
                        <p class="mb-0">{{ novaParcela.quantidadeDias }}</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-periodo-ferias_' + i">Data de Término</label>
                        <p class="mb-0" [id]="'campo-periodo-ferias_' + i">
                            {{ novaParcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only" [style.visibility]="novaParcela.situacao.descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="novaParcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + novaParcela.situacao.codigoCor + ' 100%,' + novaParcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px; padding-bottom: 10px" *ngIf="novaParcela.validacao.dataInvalida">
                    <div class="col-12 col-lg-12 mt-2">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            Data inválida!
                        </span>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px; padding-bottom: 10px" *ngIf="novaParcela.validacao.foraJanelaProgramacao">
                    <div class="col-12 col-lg-12 mt-2">
                        <span class="feedback danger" role="alert" *ngIf="regimeCeletistaOuAnistiado">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ getMsgCeletistaAnistiadoComParcelaForaPeriodoProgramacao(novaParcela) }}
                        </span>
                        <span class="feedback danger" role="alert" *ngIf="!regimeCeletistaOuAnistiado">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ getMsgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao(novaParcela) }}
                        </span>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px; padding-bottom: 10px" *ngIf="novaParcela.validacao.sobreposto">
                    <div class="col-12 col-lg-12 mt-2">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgParcelasSobrepostas }}
                        </span>
                    </div>
                </div>
                <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2" [style.visibility]="novaParcela.situacao.descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="novaParcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + novaParcela.situacao.codigoCor + ' 100%,' + novaParcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="padding-bottom: 10px">
                    <!--padding-bottom-->
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-2">
    <div class="col text-left">
        <button aria-label="botão cancelar" id="botao-cancelar" pButton type="button" label="Cancelar" class="botao-responsivo" (click)="confirmarCancelarWizard()"></button>
    </div>
    <div class="col text-right">
        <button *ngIf="wizardActiveIndex != 0" aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="secondary mr-2 botao-responsivo" (click)="voltarWizard()"></button>
        <button aria-label="botão reprogramar" id="botao-reprogramar" pButton type="submit" *ngIf="wizardActiveIndex != 1" label="Avançar" class="primary botao-responsivo" (click)="avancarWizard()"></button>
        <button aria-label="botão reprogramar" id="botao-reprogramar" pButton type="submit" *ngIf="wizardActiveIndex == 1" label="Concluir" class="primary botao-responsivo" (click)="concluirWizard()"></button>
        <!--p-button (click)="showDialog()" icon="pi pi-external-link" label="Show"></p-button-->
    </div>
</div>
<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
<p-confirmDialog key="confirmAcumuloFerias" acceptLabel="Sim" rejectLabel="Não">
    <ng-template pTemplate="message">
        <table class="confirm-dialog">
            <tr>
                <td>
                    <p id="aviso" *ngIf="!homologacaoComAcumuloFeriasNoTerceiroPeriodo">
                        <b>Aviso Importante:</b>
                        O servidor pode acumular até dois períodos de férias se houver necessidade do serviço ou em caso de licença à gestante, à adotante, licença-paternidade e licenças para tratar da própria saúde. Assim, é necessário justificar o acúmulo de férias.
                    </p>
                    <p id="aviso" *ngIf="homologacaoComAcumuloFeriasNoTerceiroPeriodo">
                        <b>Declaro, estar ciente de que a acumulação de férias por três períodos somente é permitida em situações excepcionais e por necessidade do serviço, cabendo à chefia a devida justificativa e responsabilidade por essa decisão.</b>
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    <label>
                        Justificativa para Acúmulo de Férias
                        {{ homologacaoComAcumuloFeriasNoTerceiroPeriodo ? " - Terceiro Período" : "" }}
                        (Obrigatório)
                    </label>
                    <br />
                    <textarea class="mt-1" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" [(ngModel)]="justificativaParaAcumuloFerias" maxlength="300" (input)="onJustificativaParaAcumuloFeriasChange($event)" (blur)="validarJustificativaParaAcumuloFerias()"></textarea>
                    <b>{{ justificativaParaAcumuloFerias.length }}</b>
                    de
                    <b>300</b>
                    caracteres digitados
                    <p class="mt-1" *ngIf="justificativaParaAcumuloFeriasInvalida">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgJustificativaAcumuloFeriasObrigatoria }}
                        </span>
                    </p>
                </td>
            </tr>
            <tr>
                <td style="padding-bottom: 0px !important">
                    <span>Tem certeza que deseja homologar as férias do exercício de {{ exercicioSelecionado.anoExercicio }}?</span>
                </td>
            </tr>
        </table>
    </ng-template>
</p-confirmDialog>
